import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';

// Actions
import { getWidthElement } from '../../../../actions/more/utils';

// Components
import { Text } from 'wix-ui-tpa/Text';
import { Avatar, Stats, ProfileMoreInfo, FollowBtn } from '../index';

// Constants
import {
  TABLET_WIDTH,
  MAX_PROFILE_INFO_WIDTH_DESKTOP,
} from '../../../../constants';

// Style
import { st, classes } from './ProfileHeader.st.css';

const ProfileHeader = ({
  user,
  isMobile,
  isHeaderLayoutCenter,
  headerTopPaddingDesk,
  headerLeftPaddingDesk,
  headerPaddingMobile,
  isDisplayProfileInfo,
  m_isDisplayProfileInfo,
  m_isHeaderLayoutCenter,
  isDisplayTitle,
  isBusinessApp,
  height,
  width,
  setHeaderHeight,
  isRtl,
  isEditorX,
}) => {
  const updateMarginTop = (elements, value, isWithCalc) => {
    // eslint-disable-next-line array-callback-return
    elements.map((element) => {
      if (element) {
        element.style.marginTop = isWithCalc
          ? (value.offsetHeight - element.offsetHeight) / 2 + 'px'
          : value;
      }
    });
  };

  const checkLayout = () => {
    const avatarElement = document.getElementById('profileAvatar');
    const userNameElement = document.getElementById('userName');
    const followBtnElement = document.getElementById('followBtn');
    const warpProfileInfoElement = document.getElementById('warpProfileInfo');
    const isCenter = isMobile ? m_isHeaderLayoutCenter : isHeaderLayoutCenter;

    if (userNameElement) {
      const style = window.getComputedStyle(
        document.getElementById('rootProfile'),
      );
      const paddingApp =
        parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      const minDeskWidth = TABLET_WIDTH - paddingApp;

      // If layout not center and the layout is desktop
      if (!isCenter && width > minDeskWidth) {
        const minProfileInfoDeskWidth =
          parseFloat(style.width) -
          getWidthElement(avatarElement) -
          getWidthElement(followBtnElement) -
          paddingApp;

        // Strech width of uesr name to full with
        userNameElement.style.maxWidth = minProfileInfoDeskWidth + 'px';

        if (warpProfileInfoElement) {
          // Fix profile info width - desktop
          if (minProfileInfoDeskWidth < MAX_PROFILE_INFO_WIDTH_DESKTOP) {
            warpProfileInfoElement.style.maxWidth =
              minProfileInfoDeskWidth + 'px';
          } else {
            warpProfileInfoElement.style.maxWidth =
              MAX_PROFILE_INFO_WIDTH_DESKTOP + 'px';
          }
        }

        // Center avatar and follow btn to title
        if (followBtnElement.offsetHeight < userNameElement.offsetHeight) {
          updateMarginTop(
            [avatarElement, followBtnElement],
            userNameElement,
            true,
          );
        } else if (
          (avatarElement && avatarElement.style.marginTop) ||
          (followBtnElement && followBtnElement.style.marginTop)
        ) {
          updateMarginTop([avatarElement, followBtnElement], 0);
        }
      } else {
        // If width currect - Remove all static stayles
        if (userNameElement && userNameElement.style.maxWidth) {
          userNameElement.style.maxWidth = 'unset';
        }
        if (
          (avatarElement && avatarElement.style.marginTop) ||
          (followBtnElement && followBtnElement.style.marginTop)
        ) {
          updateMarginTop([avatarElement, followBtnElement], 0);
        }
        if (
          warpProfileInfoElement &&
          warpProfileInfoElement.style.maxWidth !==
            MAX_PROFILE_INFO_WIDTH_DESKTOP + 'px'
        ) {
          warpProfileInfoElement.style.maxWidth =
            MAX_PROFILE_INFO_WIDTH_DESKTOP + 'px';
        }
      }
    }
  };

  useEffect(() => {
    checkLayout();
  });

  useEffect(() => {
    height && setHeaderHeight(height);
  }, [height]);

  const needToDisplayHeader = isMobile
    ? m_isDisplayProfileInfo
    : isDisplayProfileInfo;
  const isCenter = isMobile ? m_isHeaderLayoutCenter : isHeaderLayoutCenter;

  if (!(user && user.id)) {
    return null;
  }
  if (!needToDisplayHeader || !isBusinessApp) {
    return <div id="rootProfile" />;
  }

  return (
    <div id="rootProfile" className={st(classes.wrapper)}>
      <div
        className={st(classes.root, { isHeaderLayoutCenter: isCenter })}
        style={{
          padding: isEditorX
            ? `0px`
            : isMobile
            ? `${headerPaddingMobile}px`
            : `${headerTopPaddingDesk}px ${headerLeftPaddingDesk}px`,
        }}
      >
        <div
          className={st(classes.WarpUserNameAndAvatar, {
            isHeaderLayoutCenter: isCenter,
          })}
        >
          <Avatar isProfileHeaderIndicator={true} />
          <div
            className={st(classes.WarpProfileInfo, {
              isHeaderLayoutCenter: isCenter,
            })}
          >
            {isDisplayTitle ? (
              <Text
                id="userName"
                className={st(classes.ProfileUserName, { isMobile })}
                typography="smallTitle"
              >
                {user.username}
              </Text>
            ) : null}
            <div id="warpProfileInfo" className={st(classes.WarpInfo)}>
              <Stats isRtl={isRtl} />
              <ProfileMoreInfo />
            </div>
          </div>
        </div>
        <FollowBtn />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
  isBusinessApp: state.appReducer.isBusinessApp,
  isHeaderLayoutCenter: state.settingsReducer.isHeaderLayoutCenter,
  headerTopPaddingDesk: state.appReducer.headerTopPaddingDesk,
  headerLeftPaddingDesk: state.appReducer.headerLeftPaddingDesk,
  headerPaddingMobile: state.appReducer.headerPaddingMobile,
  isDisplayTitle: state.settingsReducer.isDisplayTitle,
  isDisplayProfileInfo: state.settingsReducer.isDisplayProfileInfo,
  m_isDisplayProfileInfo: state.settingsReducer.m_isDisplayProfileInfo,
  m_isHeaderLayoutCenter: state.settingsReducer.m_isHeaderLayoutCenter,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withResizeDetector(ProfileHeader));
